// Following the designer suggestion, the minimum width of the content area is 1050px = 1280px (size of macbook air)  - 230px(width of navbar)
const SMALL_SCREEN_WIDTH = 1280;
const NAVBAR_WIDTH = 230;
const MIN_CONTENT_WIDTH = SMALL_SCREEN_WIDTH - NAVBAR_WIDTH;

export { MIN_CONTENT_WIDTH, SMALL_SCREEN_WIDTH };
